import React from 'react'

function Veiculos({ funcao, veiculos, abrirLocalizacao, limparCampoEscolhido }) {
  const onClickLocalizacao = (veiculo) => {
    console.log("ver localizacao do veiculo = ", veiculo);
    abrirLocalizacao(veiculo);    
    limparCampoEscolhido(null);
}

  return (
    <div className="devices">
        <button onClick={() => funcao(1)}>Voltar</button>
        <h2>Veículos desde dispositivo</h2>
        {veiculos.map((veiculo) => (
        <div className="devices-preview" key={veiculo.veiculoID}>
            <h3>Veiculo: {veiculo.nome}</h3>
            <button onClick={ () => onClickLocalizacao(veiculo) }>Ver Localização</button>
        </div>
        ))}
    </div>
  )
}

export default Veiculos;